import {
  BUYING_CATEGORY,
  CH_BUYING_FEATURE,
  CH_HOME_LINK,
  CH_RENTING_FEATURE,
  CH_SELLING_FEATURE,
  CH_STUDENTS_FEATURE,
  DEFAULT_META_DESCRIPTION,
  NEWS_CATEGORIES,
  NEWS_FEATURE,
  RENTING_CATEGORY,
  SELLING_CATEGORY,
  STUDENTS_CATEGORY,
} from '@propertypal/shared/src/constants/content-hub';
import { ContentHubArticleCategory } from '@propertypal/shared/src/types/strapi/overrides';
import { getArticleCategoryParams } from '@propertypal/shared/src/utils/content-hub';
import chSubCategorySSR, {
  ContentHubSubCategoryProps,
} from '@propertypal/shared/src/utils/content-hub/chSubCategorySSR';
import getArticleCategory from '@propertypal/shared/src/utils/getArticleCategory';
import ContentHubArticleGrid from '@propertypal/web-ui/src/content-hub/ContentHubArticleGrid';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React, { FunctionComponent } from 'react';
import ContentHubLayout from '../../components/layout/ContentHubLayout';
import generateMetaTags from '../../components/layout/MetaTags';
import cachedRequest from '../../services/cachedRequest.strapi';

export const getServerSideProps: GetServerSideProps<ContentHubSubCategoryProps> = async ({ query }) => {
  const { params } = getArticleCategoryParams();
  const subCategories = await cachedRequest('/article-sub-categories', 6, params);

  const category = query.category as ContentHubArticleCategory;
  const subCategory = query.subCategory as string;
  const page = query.page as string;
  // prevent rendering any data if feature flag is not set for category
  if (
    (!CH_BUYING_FEATURE && category === BUYING_CATEGORY) ||
    (!CH_SELLING_FEATURE && category === SELLING_CATEGORY) ||
    (!CH_RENTING_FEATURE && category === RENTING_CATEGORY) ||
    (!CH_STUDENTS_FEATURE && category === STUDENTS_CATEGORY) ||
    (!NEWS_FEATURE && NEWS_CATEGORIES.includes(category))
  ) {
    return {
      redirect: {
        permanent: false,
        destination: '/',
      },
    };
  }

  const props = await chSubCategorySSR({ category, page, subCategories, subCategory });

  if (!props?.data?.data)
    return {
      notFound: true,
    };

  return {
    props: {
      ...props,
      disableHeader: true,
      disableFooter: true,
    },
  };
};

const ContentHubSubCategoryPage: FunctionComponent<ContentHubSubCategoryProps> = ({
  data,
  subCategories,
  category,
  subCategory,
  subCategoryName,
}) => {
  return (
    <>
      <Head>
        {generateMetaTags({
          title: `${getArticleCategory(category)} - ${subCategoryName} - PropertyPal`,
          url: `/${category}/${subCategory}`,
          description: DEFAULT_META_DESCRIPTION,
        })}
      </Head>

      <ContentHubLayout subCategories={subCategories}>
        <ContentHubArticleGrid
          categorySlug={category}
          subCategorySlug={subCategory}
          articles={data.data || []}
          url={`/${category}/${subCategory}`}
          page={data.meta.pagination?.page || 1}
          totalPages={data.meta.pagination?.pageCount || 1}
          homeLink={CH_HOME_LINK}
        />
      </ContentHubLayout>
    </>
  );
};

export default ContentHubSubCategoryPage;
